// @ts-nocheck
/* eslint-disable react-hooks/exhaustive-deps */
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import { CustomAutoComplete } from 'commons/AutoComplete/CustomAutoComplete';
import BasicHeader from 'components/BasicHeader/BasicHeader';
import LaboratoryCard from 'components/LaboratoryCard/LaboratoryCard';
import SkeletonLaboratoryCard from 'components/Skeletons/SkeletonLaboratoryCard/SkeletonLaboratoryCard';

import useFetch from 'hook/UseFetch';
import usePageTracking from 'hook/usePageTracking';
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { LaboratoryService } from 'services/LaboratoryService.js';
import { GENERATE_ROUTE, ROUTES } from 'utils/constants/routes';

const useStyles = makeStyles({
  marginTop: {
    marginTop: 90
  },
  filter: {
    maxWidth: 400,
    overflow: 'hidden'
  }
});

export const LaboratorySelectionPage = () => {
  const [laboratoryNames, setLaboratoryNames] = useState([]);

  usePageTracking();

  const history = useHistory();
  const classes = useStyles();

  const { response: laboratories, isLoading } = useFetch(() => LaboratoryService.getLaboratories(), []);

  const selectLaboratory = (laboratoryId) => {
    history.push(GENERATE_ROUTE(ROUTES.HOME, { laboratory: laboratoryId }));
  };

  const laboratoryCards = () => {
    const laboratoriesFiltered = laboratories.filter(
      (laboratory) => laboratoryNames.length === 0 || laboratoryNames.includes(laboratory.name)
    );
    return (
      <>
        {laboratoriesFiltered
          .map((laboratory) =>
            (
              <LaboratoryCard
                key={laboratory.id}
                laboratory={laboratory}
                onClick={() => selectLaboratory(laboratory.id)}
              />
            ))
        }
      </>
    );
  };

  const skeletonCards = (
    <>
      <SkeletonLaboratoryCard />
      <SkeletonLaboratoryCard />
      <SkeletonLaboratoryCard />
      <SkeletonLaboratoryCard />
    </>
  );

  useEffect(() => {
    if (laboratories.length === 1) {
      selectLaboratory(laboratories[0].id);
    }
  }, [laboratories]);

  return (
    <>
      <BasicHeader titleMobile="chooseLaboratory" titlePC="chooseYourLaboratory" />
      <Grid
        alignItems="center"
        className={classes.marginTop}
        container
        direction="row"
        justifyContent="space-evenly"
      >
        <CustomAutoComplete
          className={classes.filter}
          isMultiple
          isTranslatingOptions
          label="laboratories"
          onChange={(event, value) => setLaboratoryNames(value)}
          options={laboratories && laboratories.map((c) => c.name)}
          valueName="laboratories"
        />
      </Grid>
      <Grid
        alignItems="center"
        className={classes.marginTop}
        container
        direction="row"
        justifyContent="space-evenly"
      >
        {isLoading ? skeletonCards : laboratoryCards()}
      </Grid>
    </>
  );
};